import React from "react";
import { ArrowRight } from "lucide-react";
import { useBooking } from "@/contexts/BookingContext";
import { trackEvent } from "@/lib/analytics";

const STYLES = {
  sand: "bg-[#B3A17D] text-[#2B1017] hover:bg-white",
  burgundy: "bg-[#451C25] text-white hover:bg-[#2B1017]",
  ivory: "bg-[#F5EFE7] text-[#451C25] hover:bg-white",
  outline: "border-2 border-[#B3A17D] text-white hover:bg-[#B3A17D] hover:text-[#2B1017]",
};

// Single primary CTA used everywhere. Opens the embedded Google Calendar booking panel (CMS: booking.calendar_url).
export function ScheduleCallButton({ label, source, tone = "sand", size = "md", testId, className = "", onClick: onBefore, extra = {} }) {
  const { open } = useBooking();
  const pad = size === "sm" ? "px-5 py-2.5 text-[11px] tracking-[0.18em]" : "px-9 py-4 md:py-5 text-[12px] md:text-[13px] tracking-[0.2em]";

  const onClick = () => {
    onBefore?.();
    trackEvent("schedule_call_click", { placement: source || "unknown", mode: "embedded", country: "spain", page_path: window.location.pathname, ...extra });
    open(source);
  };

  return (
    <button
      type="button"
      data-testid={testId || `cta-schedule-${source || "call"}`}
      onClick={onClick}
      className={`group inline-flex items-center justify-center gap-3 uppercase font-semibold transition-colors rounded-none ${STYLES[tone]} ${pad} ${className}`}
      style={{ fontFamily: "Kanit, Arial, sans-serif" }}
    >
      {label || "Schedule a Free Call"}
      <ArrowRight size={size === "sm" ? 14 : 16} className="transition-transform group-hover:translate-x-1" />
    </button>
  );
}

export default ScheduleCallButton;
